const debug = (msg) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(msg + " @ " + performance.now())
  }
}

export { debug }
